export default "__VITE_ASSET__894a2d04__"